import * as React from "react";
import { Icon } from "./Icon";

export class DownIcon extends Icon {

	render() {
		return <Icon {...this.props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
				<polygon points="16 24.83 2.59 11.41 5.41 8.59 16 19.17 26.59 8.59 29.41 11.41 16 24.83" />
			</svg>
		</Icon>;
	}
}
